module.exports = __webpack_public_path__ + "static/img/invest-TMT4.0a4f2e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-TMT4.jpg
// module id = B6XM
// module chunks = 0